import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { UseOutletContext } from '../Main';
import { StateLanguage } from '../../../languages/config/StateLanguage';
import { ApiDigitalAuthInvitation } from '../../../services/auth/invitation.service';
import { Error } from '../../../models/error.model';
import { Invitation } from '../../../models/invitation.model';
import { GlobalSwal } from '../../../styles/swal.style';
import { modalShow } from '../../../utils/modal.util';
import { getError } from '../../../languages/translations/response';
import { errorWebHandler } from '../../../scripts/error.web.handler.script';

import AppModalInvitationList from '../../../components/modal/ModalInvitationList';
import welcome from '../../../assets/themes/images/welcome.svg';

export interface WelcomePageProps {};

let errorResponse: Error, invitationsResponse: Invitation[];

const WelcomePage: React.FunctionComponent<WelcomePageProps> = props => {
  const {setRoute, appServiceForUser, reloadSession} = UseOutletContext()
  const {lang} = StateLanguage()

  const [mounted, setMounted] = useState(false)
  const [invitations, setInvitations] = useState<Invitation[] | null>(null)

  const loadInvitations = async (api_key: string) => {
    await ApiDigitalAuthInvitation.getMyInvitations(api_key).then( (response) => {
      if (response.status === 200) {
        invitationsResponse = response.data
        setInvitations(invitationsResponse.filter((item) => (item.status === 'pending')))
      } else {
        errorResponse = response.data

        GlobalSwal.fire({
          title: getError(errorResponse.code, lang.code, errorResponse.message),
          text: lang.labels.sorryLooksLikeThereAreSomeErrorstryAgain,
          icon: 'error',
          confirmButtonText: lang.labels.okGotIt
        })
      }
    }).catch( (error) => {
      errorWebHandler(lang, error)
    })
  }

  const executeShowModalNotificationMain = () => {
    if (!appServiceForUser) return null

    loadInvitations(appServiceForUser.api_key)
    modalShow('modal-invitation-list')
  }

  useEffect( () => {
    setMounted(true)
    setRoute({path: null, company: false})

    return () => setMounted(false)

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!mounted) return null

  return (
    <div className="w-100 h-100">
      <div className="card">
        <div className="card-body">
          <div className="card-px text-center mb-5">
            <h1 className="fs-2x mb-10">{lang.labels.welcomeToDigitalAdmin}</h1>
            <p className="text-muted fs-5 fw-semibold mb-10">
              {lang.labels.planYourBusinessApplications}
              <br/>
              {lang.labels.ourServicesOrRequesting}
            </p>
            <Link to="/main/company/create" className="btn btn-primary m-3">{lang.labels.createCompany}</Link>
            <button className="btn btn-primary m-3" type="button" onClick={executeShowModalNotificationMain}>{lang.labels.viewInvitations}</button>
          </div>
          <div className="text-center">
            <img src={welcome} alt={lang.labels.welcome} className="mw-100 mh-200px mh-lg-250px" />
          </div>
        </div>
      </div>
      <AppModalInvitationList appServiceForUser={appServiceForUser} invitations={invitations} loadInvitations={loadInvitations} reloadSession={reloadSession}></AppModalInvitationList>
    </div>
  )
};

export default WelcomePage;
